import { BASE_URL } from '@/services/api'
import {request, METHOD} from '@/utils/request'


let PUSH_MESSAGE= `${BASE_URL}/push/pushMessage`
let CHECK_MESSAGE= `${BASE_URL}/push/checkMessage`
let CHANGE_MESSAGE_STATUS= `${BASE_URL}/push/changeMessageStatus`
let PUSH_SCHEDULE_MESSAGE= `${BASE_URL}/push/pushScheduleMessage`



export async function pushMessage(params) {
  return request(PUSH_MESSAGE, METHOD.POST, params)
}
export async function checkMessage(params) {
  return request(CHECK_MESSAGE, METHOD.POST, params)
}
export async function changeMessageStatus(params) {
  return request(CHANGE_MESSAGE_STATUS, METHOD.POST, params)
}
export async function pushScheduleMessage(params) {
  return request(PUSH_SCHEDULE_MESSAGE, METHOD.POST, params)
}

export default {
  pushMessage,
  checkMessage,
  changeMessageStatus,
  pushScheduleMessage,
}
